import type { DnsRecordRequest, DnsRecordView, NameServerChangeView, RedirectRequest, RedirectView, SiteDnsView } from '@/types/api';
import { apiRequest } from '@/api/client';

const base = (siteId: string, domainId: string) => `/sites/${siteId}/dns/${encodeURIComponent(domainId)}`;

/** A site's DNS records and Cloudflare settings, through the panel and 2d2s (ADR-0032). */
export const domainsApi = {
  view: (siteId: string) => apiRequest<SiteDnsView>(`/sites/${siteId}/dns`),

  createRecord: (siteId: string, domainId: string, record: DnsRecordRequest) =>
    apiRequest<DnsRecordView>(`${base(siteId, domainId)}/records`, { method: 'POST', body: record }),

  updateRecord: (siteId: string, domainId: string, recordId: string, record: DnsRecordRequest) =>
    apiRequest<DnsRecordView>(`${base(siteId, domainId)}/records/${encodeURIComponent(recordId)}`, { method: 'PATCH', body: record }),

  deleteRecord: (siteId: string, domainId: string, recordId: string) =>
    apiRequest<{ deleted: boolean }>(`${base(siteId, domainId)}/records/${encodeURIComponent(recordId)}`, { method: 'DELETE' }),

  setSslMode: (siteId: string, domainId: string, mode: string) =>
    apiRequest<{ sslMode: string }>(`${base(siteId, domainId)}/ssl`, { method: 'PUT', body: { mode } }),

  setAlwaysHttps: (siteId: string, domainId: string, enabled: boolean) =>
    apiRequest<{ alwaysUseHttps: boolean }>(`${base(siteId, domainId)}/always-https`, { method: 'PUT', body: { enabled } }),

  purgeCache: (siteId: string, domainId: string) =>
    apiRequest<{ purged: boolean }>(`${base(siteId, domainId)}/purge-cache`, { method: 'POST' }),

  nameServers: (siteId: string, domainId: string) => apiRequest<NameServerChangeView[]>(`${base(siteId, domainId)}/name-servers`),

  redirects: (siteId: string, domainId: string) => apiRequest<RedirectView[]>(`${base(siteId, domainId)}/redirects`),

  createRedirect: (siteId: string, domainId: string, redirect: RedirectRequest) =>
    apiRequest<RedirectView>(`${base(siteId, domainId)}/redirects`, { method: 'POST', body: redirect }),

  updateRedirect: (siteId: string, domainId: string, redirectId: string, redirect: RedirectRequest) =>
    apiRequest<RedirectView>(`${base(siteId, domainId)}/redirects/${encodeURIComponent(redirectId)}`, { method: 'PATCH', body: redirect }),

  deleteRedirect: (siteId: string, domainId: string, redirectId: string) =>
    apiRequest<{ deleted: boolean }>(`${base(siteId, domainId)}/redirects/${encodeURIComponent(redirectId)}`, { method: 'DELETE' }),
};
